import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
  contentContainer: {
    [theme.breakpoints.up('md')]: {
      marginTop: '128px',
      height: '100%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '46px',
      height: 'calc(100% + 32px)',
    },
    position: 'relative',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  },
  opened: {
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 285px)',
      marginLeft: '285px',
    },
  },
  closed: {
    width: '100%',
    marginLeft: '0',
  },
});

class Root extends React.Component {
  render() {
    let { classes, asideOpen } = this.props;

    return (
      <div
        className={classNames(
          classes.contentContainer,
          {
            [classes.opened]: asideOpen,
          },
          {
            [classes.closed]: !asideOpen,
          }
        )}
      >
        {this.props.children}
      </div>
    );
  }
}

export default withStyles(styles)(Root);



// WEBPACK FOOTER //
// ./src/components/Root.js